export default __webpack_public_path__ + "locales/el-GR/Files.json?hash=c054caf8d4439955b6f3f40efea1dcb7";